/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    CURRENCY_PHASE1_PROFILE_PREFERENCE
 * Date:         2026-02-13
 * Modified By:  Claude Code
 *
 * Description:
 * Expanded Currency module with labels, symbols, eurozone mapping,
 * and getCurrencyForCountry() auto-detect helper for profile form.
 *
 * File Size Check:
 * - Current: 4 lines
 * - Adding: ~45 lines
 * - Projected: ~49 lines
 * - Decision: Proceed (well within limits)
 *
 * Related Files:
 * - client/src/components/setup/user-profile/components/PersonalInformation.tsx
 * - client/src/constants/tooltips.ts
 */

// Shared currency types to avoid conflicts between interfaces
export type Currency = "USD" | "EUR" | "GBP";

export const CURRENCIES: Currency[] = ["USD", "EUR", "GBP"];

// [2026-02-13] CURRENCY_PHASE1: Display labels with symbol for dropdowns
export const CURRENCY_LABELS: Record<Currency, string> = {
  USD: "USD ($)",
  EUR: "EUR (€)",
  GBP: "GBP (£)",
};

// [2026-02-13] CURRENCY_PHASE1: Symbol map for formatting
export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
};

// [2026-02-13] CURRENCY_PHASE1: Eurozone countries that use EUR
const EUROZONE_COUNTRIES: string[] = [
  "Austria", "Belgium", "Croatia", "Cyprus", "Estonia",
  "Finland", "France", "Germany", "Greece", "Ireland",
  "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta",
  "Netherlands", "Portugal", "Slovakia", "Slovenia", "Spain",
];

// [2026-02-13] CURRENCY_PHASE1: Auto-detect currency from country selection
export function getCurrencyForCountry(country: string): Currency {
  if (EUROZONE_COUNTRIES.includes(country)) return "EUR";
  if (country === "United Kingdom") return "GBP";
  return "USD";
}
